module.exports = __webpack_public_path__ + "img/849-a556a5.png";